import React from "react";
import HelpIcon from "../Help/HelpIcon";
import {GroupEventDetailsProps} from "../../types/groupEventDetails";

interface GroupEventDetailsComponentProps {
  groupEventDetails?: GroupEventDetailsProps;
}

const GroupEventDetails: React.FC<GroupEventDetailsComponentProps> = ({groupEventDetails}) => {
  if (!groupEventDetails) {
    return null;
  }

  const formatBooleanValue = (value: boolean): string => {
    return value ? "Yes" : "No";
  };

  const formatGroupName = (groupName: string, subgroupName: string): string => {
    return `${groupName} - Subgroup: ${subgroupName}`;
  };

  return (
    <div className="group-event-details">
      <h6 className="text-muted mb-2">
        <i className="fa fa-users mr-2"></i>
        Group Event Details
        <HelpIcon topicId="groupEventDetails" />
      </h6>
      <div className="group-event-grid">
        <div className="metric-item">
          <span className="metric-label">Group Event</span>
          <span className="group-event-value">
            {formatGroupName(groupEventDetails.groupName, groupEventDetails.subgroupName)}
          </span>
        </div>
        <div className="metric-item">
          <span className="metric-label">Start Time</span>
          <span className="group-event-value">{groupEventDetails.startTime}</span>
        </div>
        <div className="metric-item">
          <span className="metric-label">Braking Available</span>
          <span className="group-event-value">{formatBooleanValue(groupEventDetails.isBrakingAvailable)}</span>
        </div>
        <div className="metric-item">
          <span className="metric-label">Steering Available</span>
          <span className="group-event-value">{formatBooleanValue(groupEventDetails.isSteeringAvailable)}</span>
        </div>
        <div className="metric-item">
          <span className="metric-label">Rubber Banding v2</span>
          <span className="group-event-value">{formatBooleanValue(groupEventDetails.isRubberBanding)}</span>
        </div>
        <div className="metric-item">
          <span className="metric-label">Late Join Allowed</span>
          <span className="group-event-value">{formatBooleanValue(groupEventDetails.isLateJoin)}</span>
        </div>
      </div>
    </div>
  );
};

export default GroupEventDetails;
